import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { RackComponent } from 'src/app/models/components/objectComponents/RackComponent';
import { PodestComponent } from 'src/app/models/components/commonComponents/PodestComponent';
import { Box } from 'src/app/models/other/box.model';

import { ModalDialog } from 'src/app/Modal/modal';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox'
import { Shelf } from 'src/app/models/other/shelf.model';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { RackSecurity } from 'src/app/models/RackSecurity.model';

import { userHasFeature } from 'src/app/helper/userHasFeature';
import { AuthService } from 'src/app/services/auth.service';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-rack',
  templateUrl: './rack.component.html',
  styleUrls: ['./rack.component.css']
})
export class RackViewComponent extends BaseAdvancedPropertyViewComponent {
  rack: RackComponent = new RackComponent();
  podest: PodestComponent = new PodestComponent();

  securityTypes: RackSecurity[] = [];

  shelfArrLeft: Array<Shelf> = new Array<Shelf>();
  shelfArrRight: Array<Shelf> = new Array<Shelf>();
  showFeatureSecurity: boolean;
  isRemoveShelfDisabled: boolean = true;
  integerOnly = InputHelper.integerOnly;

  constructor(private dialog: MatDialog, private authService: AuthService, public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    //this is needed to avoid the ExpressionChangedAfterItHasBeenCheckedError during DEV mode caused by an additional ChangeDetection run!!!
    setTimeout(() => {
      this.rack = getComponentFromSource(ComponentNames.rackComponent, this.items);
      this.podest = getComponentFromSource(ComponentNames.podestComponent, this.items);
      this.securityTypes = this.additionalData.rackSecurityList;

      if (this.rack.seperator) {
        this.shelfArrLeft = this.rack.shelves[0];
        this.shelfArrRight = this.rack.shelves[1];
      } else {
        this.shelfArrLeft = this.rack.shelves[0];
        this.shelfArrRight = new Array<Shelf>();
      }
      this.changeIsRemoveShelfDisabled();
    }, 0);

    this.checkFeature();
  }

  checkFeature() {
    this.showFeatureSecurity = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideBaggageRackLarge);
  }

  addShelf() {
    if (this.rack.seperator) {
      if (this.shelfArrLeft.length === 0) {
        let shelf: Shelf = new Shelf();
        shelf.box = new Box();
        shelf.shelfStart = 0;
        let shelf1: Shelf = new Shelf();
        shelf1.box = new Box();
        shelf1.shelfStart = 0;
        this.shelfArrLeft.push(shelf);
        this.shelfArrRight.push(shelf1);
      }
      else {
        let shelf: Shelf = JSON.parse(JSON.stringify(this.shelfArrLeft[this.shelfArrLeft.length - 1]));
        let shelf1: Shelf = JSON.parse(JSON.stringify(this.shelfArrRight[this.shelfArrRight.length - 1]));
        this.shelfArrLeft.push(shelf);
        this.shelfArrRight.push(shelf1);
      }
    } else {
      if (this.shelfArrLeft.length === 0) {
        let shelf: Shelf = new Shelf();
        shelf.box = new Box();
        shelf.shelfStart = 0;
        this.shelfArrLeft.push(shelf);
      }
      else {
        let shelf: Shelf = JSON.parse(JSON.stringify(this.shelfArrLeft[this.shelfArrLeft.length - 1]));
        this.shelfArrLeft.push(shelf);
      }
    }
    this.changeIsRemoveShelfDisabled();
  }

  removeShelf() {
    if (this.rack.seperator) {
      this.shelfArrLeft.pop();
      this.shelfArrRight.pop();
    } else {
      this.shelfArrLeft.pop();
    }
    this.changeIsRemoveShelfDisabled();
  }

  onRackSeperatorChange(evt: MatCheckboxChange) {
    if (this.shelfArrLeft.length === 0) {
      this.rack.seperator = evt.checked;
    }
    else if (this.rack.seperator === false) {
      this.userSettingSeperatorWarning(evt);
    }
    else {
      this.userRemovingSeperatorWarning(evt);
    }
  }

  userRemovingSeperatorWarning(evt: MatCheckboxChange) {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: 'Removing The Intermediate Stand, Resets Already Configured Rack Compartments. Continue?',
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Okay'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rack.seperator = false;
        this.shelfArrLeft = new Array<Shelf>();
        this.shelfArrRight = new Array<Shelf>();
      } else {
        this.rack.seperator = true;
        evt.source.checked = true;
      }
    });
  }

  userSettingSeperatorWarning(evt: MatCheckboxChange) {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: 'Setting An Intermediate Stand Resets Already Configured Rack Compartments. Continue?',
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Okay'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rack.seperator = true;
        this.shelfArrLeft = new Array<Shelf>();
        this.shelfArrRight = new Array<Shelf>();
      } else {
        this.rack.seperator = false;
        evt.source.checked = false;
      }
    });
  }

  changeSecurityType(selectedValue: number) {
    this.rack.security = selectedValue;
  }

  saveButtonDisabledState(): boolean {
    let disable = false;

    if (this.baseDimension.box.height < 0)
      disable = true;
    if (this.podest.height < 0)
      disable = true;
    if (this.rack.wallThickness < 0)
      disable = true;
    if (this.rack.floorThickness < 0)
      disable = true;
    if (this.rack.seperator && this.rack.seperatorThickness < 0)
      disable = true;
    if (this.shelfArrLeft.length === 0)
      disable = true;
    if (this.validateShelfInputs() === false)
      disable = true;
    if (this.validateRackHeight() === false)
      disable = true;
    if (this.validateRackWidth() === false)
      disable = true;

    return disable;
  }

  validateShelfInputs(): boolean {
    let valid = true;

    for (let index = 0; index < this.shelfArrLeft.length; index++) {
      const elementLeft = this.shelfArrLeft[index];
      const elementRight = this.shelfArrRight[index];

      if (elementLeft.box.length < 0 || this.rack.seperator && elementRight.box.length < 0)
        valid = false;
      if (elementLeft.box.height < 0 || this.rack.seperator && elementRight.box.height < 0)
        valid = false;
      if (elementLeft.box.width < 0 || this.rack.seperator && elementRight.box.width < 0)
        valid = false;

      if (!valid)
        break;
    }
    return valid;
  }

  validateRackWidth(): boolean {
    let valid = true;
    let toleranceFactor: number = 1.3;

    if (this.rack.seperator) {
      for (let index = 0; index < this.shelfArrLeft.length; index++) {
        const elementLeft = this.shelfArrLeft[index];
        const elementRight = this.shelfArrRight[index];
        let totalWidth = elementLeft.box.width + elementRight.box.width + this.rack.seperatorThickness + (this.rack.wallThickness * 2);
        if (totalWidth > this.baseDimension.box.width) {
          valid = false;
          break;
        }
      }
    }
    else {
      for (let index = 0; index < this.shelfArrLeft.length; index++) {
        const element = this.shelfArrLeft[index];
        let widthLeft = element.box.width + (this.rack.wallThickness * 2);
        if (widthLeft > (this.baseDimension.box.width * toleranceFactor)) {
          valid = false;
          break;
        }
      }
    }

    return valid;
  }

  validateRackHeight(): boolean {
    let valid = false;

    if (this.rack.seperator) {
      let heightLeft = 0, heightRight = 0;
      this.shelfArrLeft.forEach(element => {
        heightLeft += element.box.height;
      });
      this.shelfArrRight.forEach(element => {
        heightRight += element.box.height;
      });
      if (heightLeft <= this.baseDimension.box.height && heightRight <= this.baseDimension.box.height)
        valid = true;
    } else {
      let heightLeft = 0;
      // factor to multiply the floorthickness, shelf amount -1
      let floorThicknessMultiplier = this.shelfArrLeft.length - 1;
      for (let index = 0; index < this.shelfArrLeft.length; index++) {
        const element = this.shelfArrLeft[index];
        heightLeft += element.box.height;
      }
      // all shelf heights + podest height + (floorthickness * amount of shelves -1)
      heightLeft = heightLeft + this.podest.height + (this.rack.floorThickness * floorThicknessMultiplier);

      if (heightLeft <= this.baseDimension.box.height)
        valid = true;
    }

    return valid;
  }

  changeIsRemoveShelfDisabled() {
    if (this.shelfArrLeft.length > 0) {
      this.isRemoveShelfDisabled = false;
    }
    else {
      this.isRemoveShelfDisabled = true;
    }
  }
}